import React from 'react'
import SlideOver from '@molecules/SlideOver/SlideOver'
import IconButton from '@molecules/IconButton/IconButton'
import { SideFlyoutContainerProps } from './SideFlyoutContainer.types'

const SideFlyoutContainer = ({
  className,
  children,
  titleContent,
  fixedTitle,
  width = 'w-screen md:w-[422px]',
  zIndex = 'z-10',
  marginBotton = 'mb-2',
  position = 'right',
  iconHeight = '20px',
  isOpen,
  onOpen,
  onClose,
  isDarkMode = false,
  ...props
}: SideFlyoutContainerProps) => {
  const closeButton = (
    <div
      className={`flex h-5 w-5 items-center ${
        isDarkMode ? 'fill-white' : 'fill-black'
      }`}
    >
      <IconButton iconName={'Close'} onClick={onClose} height={iconHeight} />
    </div>
  )

  return (
    <SlideOver
      position={position}
      isOpen={isOpen}
      onOpen={onOpen}
      onClose={onClose}
      backdropOpacity={'bg-opacity-25'}
      {...props}
    >
      <div
        data-testid='side-flyout-container'
        className={`flex h-full flex-col transition-all duration-500 ease-out ${
          isDarkMode ? 'bg-black' : 'bg-white'
        } ${width} ${className || ''}`}
      >
        <div
          className={`transition-all duration-500 ease-out ${
            fixedTitle && 'fixed'
          } ${width} font-Roboto leading-12 text-12 tracking-0 ${zIndex} ${marginBotton} flex flex-nowrap ${
            isDarkMode ? 'bg-black' : 'bg-white'
          } px-10 pb-4 pt-10 uppercase`}
        >
          {position === 'left' && closeButton}
          <div
            className={`grow ${isDarkMode ? 'text-white' : 'text-black'} ${
              position === 'right' ? 'pr-6' : 'pl-6'
            }`}
          >
            {titleContent}
          </div>
          {position === 'right' && closeButton}
        </div>
        {children}
      </div>
    </SlideOver>
  )
}

export default SideFlyoutContainer
